import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import FilterClientForm from './FilterClientForm';
import Clients from './Clients';
import EditClient2 from './EditClient2';
import AddClientForm from './AddClientForm';
import {
  loadClientData
} from '../../actions/advisor';
import {
  getEditClient,
  getAddClient,
} from '../../reducers/advisor';
import s from './AdvisorMode.css';

class AdvisorMode extends PureComponent {

  componentWillMount() {
    this.props.loadClientData();
  }

  render() {
    const {
      editClient,
      addClient,
    } = this.props;

    return (
      <div className={s.bhvfin}>
        <FilterClientForm client={editClient} />
        { !editClient && !addClient &&
          <Clients />
        }
        { editClient &&
          <div>
            <EditClient2 client={editClient} />
          </div>
        }
        { addClient &&
          <AddClientForm />
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    editClient: getEditClient(state),
    addClient: getAddClient(state),
  };
}

export default connect(mapStateToProps, {
  loadClientData,
})(AdvisorMode);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/AdvisorMode.js